function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.207 76.8196L31.6754 51.9569H26.7287C25.6135 51.9569 24.6127 51.5202 23.8979 50.8379C23.1831 50.1556 22.7256 49.1731 22.7256 48.136C22.7256 47.0716 23.1831 46.1164 23.8979 45.4341C24.6127 44.7519 25.6135 44.3152 26.7287 44.3152C27.8438 44.3152 28.8446 44.7519 29.5595 45.4341C30.2743 46.1164 30.7318 47.0716 30.7318 48.136V50.9198L53.1779 50.8925V0.839569H0.965706V50.6469H13.0037V45.0521H6.82743V6.40707H47.3448V45.325H36.1646C35.6785 43.8512 34.8207 42.5139 33.7056 41.4496C31.9328 39.7575 29.4451 38.6931 26.7287 38.6931C24.0123 38.6931 21.5532 39.7575 19.7804 41.4496C18.0076 43.1689 16.8924 45.516 16.8924 48.0814C16.8924 50.6741 18.0076 53.0212 19.7804 54.7406C20.5238 55.4502 21.4102 56.0506 22.3538 56.5146L12.1173 74.0904L17.207 76.8196Z",
  fill: "#FFCC00"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 77,
    viewBox: "0 0 54 77",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.e42040aa.svg";
export { ForwardRef as ReactComponent };